<template>
    <!-- merchant -->
        <div class="c-merchant-list" v-for="app in companyApps">
            <div class="c-merchant-list__name">
                <ul v-if="app.has_subscription" class="c-merchant__label">
                    <li class="label"><span>{{ $t('LABEL_RECURRING_BILLING') }}</span></li>
                </ul>
                <p class="c-merchant__name">
                    <span v-if="(app.toppage_url == null || app.toppage_url === '') == true" >{{ app.site_name }}</span>
                    <a v-else :href="app.toppage_url" target="_blank">{{ app.site_name }}</a>
                </p>
            </div>
            <div class="c-merchant-list__status">
                <div :class="'c-merchant__state' + ' ' + STATUS_CLASS[app.status]">
                    <p class="state">{{ $t(app.status) }}</p>
                    <p v-if="app.status != 'suspended_resigned' && app.status != 'merch_suspended'" class="date">{{constants.STATUS_DATE_LABEL[app.status] + ": "}}{{ app[getDateKey(app.status)] }}</p>
                </div>
                <div class="c-merchant__refusal">
                    <button :disabled="isRefusalDisabled(app)" :id="'company-app-' + app.company_app_id" class="c-btn__refusal" v-on:click="redirectToResignPage(app.app_resign_url)">退会手続き</button>
                </div>
            </div>
        </div>
        <!-- more -->
</template>

<script setup>
import CONSTS from "@/data/constants";
import { STATUS_CLASS } from "@/data/constants";
import { defineProps, defineEmits, computed } from "vue";
import { useI18n } from "vue-i18n";

const props = defineProps(['companyApps']);
const emit = defineEmits(["refreshMerchants"]);

const { locale } = useI18n();
const constants = computed(() => {
    return CONSTS[locale.value];
});

function getDateKey(status) {
    let key = "use_app_update_timestamp";
    if (status == "merch_suspended") {
        key = "merchat_update_timestamp";
    }
    
    return key;
}

function redirectToResignPage(url) {
    if (url != null && url !== '') {
        window.open(url, '_blank');
    }
}

function isRefusalDisabled(app) {
    return (
        app.status !== 'active' ||
        !app.toppage_url || app.toppage_url === '' ||
        !app.app_resign_url || app.app_resign_url === ''
    );
}
</script>